import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
export default function Youtube(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? null : _ref$url,
      _ref$videoId = _ref.videoId,
      videoId = _ref$videoId === void 0 ? null : _ref$videoId;
  if (videoId) url = "https://www.youtube.com/embed/".concat(videoId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("iframe", {
      src: url,
      frameBorder: "0",
      allowFullScreen: true,
      className: "jsx-3046293284" + " " + 'video'
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3046293284",
      children: [".video.jsx-3046293284{width:100%;height:100%;}"]
    })]
  });
}